import { TablePaginationConfig } from "antd";
import { passengersApi } from "api/passenger";
import { useNotificationContext } from "contexts/NotificationContext";
import { ITableData, defaultTableData } from "models";
import { IUser } from "models/user";
import { ChangeEvent, useEffect, useState } from "react";

export default function usePassengers() {
  const { showError } = useNotificationContext();
  const [data, setData] = useState<ITableData<IUser>>(defaultTableData);
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [data.page, data.search]);

  const fetchData = async () => {
    setData((prev) => ({ ...prev, loading: true }));
    const { data: response, error } = await passengersApi(
      data.page,
      data.per_page,
      data.search
    );
    if (response) {
      response.data = response.data.map((value) => ({
        ...value,
        key: value.id,
      }));
      setData((prev) => ({ ...prev, ...response }));
    } else showError(error!.message);
    setData((prev) => ({ ...prev, loading: false }));
  };

  const handlePageChange = ({ current }: TablePaginationConfig) => {
    if (current) setData((prev) => ({ ...prev, page: current }));
  };

  const handleSearch = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({ ...prev, search: value ?? "" }));
  };

  return { data, handlePageChange, handleSearch, fetchData };
}
